import {CommandManager} from "../libs/CommandManager";
import {ReaderService} from "../services/ReaderService";
import {Reader} from "../entities/Reader";
import {QueuedCommand} from "../entities/QueuedCommand";

export class CommandSetReportingIntervalCtrl {
    commandEnabled:boolean = false;
    readers:Reader[];
    selectedReader:Reader;
    reportingIntervals = ["15 Minutes", "30 Minutes", "1 Hour", "2 Hours", "4 Hours", "6 Hours", "12 Hours", "24 Hours"];
    selectedReportingInterval = "1 Hour";
    static $inject = ['CommandManager','ReaderService'];
    constructor(public commandManager:CommandManager, public readerService:ReaderService) {
        this.readerService.getGateways().then((data)=>{
            this.readers = data;
            if(data.length > 0)
                this.selectedReader = data[0];
        })
    }
    runCommand(){
        var queuedCommand = new QueuedCommand(null,null,"Set Reporting Interval",this.selectedReportingInterval+":"+this.selectedReader.name,this.selectedReader.id);
        this.commandManager.runCommands([queuedCommand]);
    }
}

export class CommandSetReportingIntervalDirective implements ng.IDirective {
    restrict= 'AEC';
    transclude = false;
    template = require('../../views/cmdsetreportinginterval.html').default;
    scope = {
        commandEnabled : "=",
    };
    constructor() {
    }
    controller = CommandSetReportingIntervalCtrl;
    controllerAs = "vm";
    link(scope: any, element: ng.IAugmentedJQuery, attributes: ng.IAttributes, controller: any): void {
        //let url = controller.getUrl();
        //element.text('Current URL: ' + url);
        controller.commandEnabled = scope.commandEnabled;
        scope.$watch(()=>scope.commandEnabled, (newVal:any)=> {
            controller.commandEnabled = scope.commandEnabled;
        });
    }
    static factory():ng.IDirectiveFactory {
        var directive = () => {
            return new CommandSetReportingIntervalDirective();
        }
        return directive;
    }
}
